import { render, staticRenderFns } from "./RealEstate.vue?vue&type=template&id=03a45a16&"
import script from "./RealEstate.vue?vue&type=script&lang=ts&"
export * from "./RealEstate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports